/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, answerError } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED QUESTION : STYLES --------------- ++++++++++ */
export default theme => ({
	question: {
		height: '30%',
		textAlign: 'left',
		// paddingTop: pxToEm(10),
		position: 'relative',
		zIndex: '3',
		outline: 'solid 0px #fff0',
        transition: 'outline 0.2s linear',
        '& .text': {
			// 24 chars per line at 22px fontsize
			// 56 is limit for 3 lines at 22px fontsize
			height: '100%',
			fontSize: pxToEm(18),
			fontWeight: 'normal',
			lineHeight: '1.1',
            '&.medium': { fontSize: pxToEm(17), lineHeight: '1.15' },
            '&.small': { fontSize: pxToEm(16), lineHeight: '1.15' },
            '&.xsmall': { fontSize: pxToEm(15), lineHeight: '1.15' },
            '&.xxsmall': { fontSize: pxToEm(13.5), lineHeight: '1.25', paddingTop: '0' },
            '&.xxxsmall': { fontSize: pxToEm(12.5), lineHeight: '1.25', paddingTop: '0' },
            '&.x4small': { fontSize: pxToEm(11.5), lineHeight: '1.25', paddingTop: '0' },
            '&.x5small': { fontSize: pxToEm(10.5), lineHeight: '1.25', paddingTop: '0' },
            '&.x6small': { fontSize: pxToEm(9.5), lineHeight: '1.25', paddingTop: '0' },
            '&.x7small': { fontSize: pxToEm(8.5), lineHeight: '1.25', paddingTop: '0' },
            '&.x8small': { fontSize: pxToEm(8), lineHeight: '1.25', paddingTop: '0' }
		},
		'&.valid-false': {
            extend: answerError.text
		},

        // not supported in IE https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
        '&:focus-within': {
            outlineWidth: pxToEm(1),
			outlineColor: '#fff',
            '&.valid-false': {
                border: 'none',
                outlineColor: theme.color.warning.dark.swatch
			}
        }
	}
});
